"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.assign.js");

require("antd/lib/alert/style");

var _alert = _interopRequireDefault(require("antd/lib/alert"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

require("./Alert.less");

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["extra", "message", "className", "noBackground"];
var _default = Alert;
exports.default = _default;

function Alert(_ref) {
  var extra = _ref.extra,
      message = _ref.message,
      className = _ref.className,
      noBackground = _ref.noBackground,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_alert.default, Object.assign({
    className: (0, _classnames.default)('Alert', className, {
      'Alert_no-background': noBackground
    }),
    message: /*#__PURE__*/_react.default.createElement("span", {
      className: 'Alert_message-wrapper'
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: 'Alert_message'
    }, message), /*#__PURE__*/_react.default.createElement("span", {
      className: 'Alert_extra'
    }, extra))
  }, rest));
}